<!-- 资料管理 -->
<template>
    <div>
      <div class="course_ResourcesList">
        <el-row>
          <label>课程：</label>
          <el-select @change="getCourseInfoList" v-model="search.courseId" placeholder="请选择归属课程">
            <template v-for="(item ,index) in courseList">
              <el-option :label="item.teacherOpenCourseIdText || item.teacherOpenCourseTitle" :value="item.teacherOpenCourseId"></el-option>
            </template>
          </el-select>
          <label class="ml20">归属章节：</label>
          <el-select clearable v-model="search.teacherOpenCourseMergeCourseInfoId" placeholder="请选择课程">
            <template v-for="(item ,index) in courseInfoList">
              <el-option :label="item.courseInfoName" :value="item.teacherOpenCourseMergeCourseInfoId"></el-option>
            </template>
          </el-select>
          <label>资料类型：</label>
          <!-- 1	视频 2	PPT 3	PDF 4	链接 5	图文 -->
          <el-select clearable class="mb20" style="width: 150px;" v-model="search.resourcesInfoType" placeholder="请选择类型">
            <el-option label="视频" value="1"></el-option>
            <el-option label="PPT" value="2"></el-option>
            <el-option label="PDF" value="3"></el-option>
            <el-option label="链接" value="4"></el-option>
            <el-option label="图文" value="5"></el-option>
          </el-select>
          <label>资料名称：</label>
          <el-input type="text" style="width: 200px;" clearable v-model="search.resourcesInfoName" />
          <el-button type="primary" icon="el-icon-search" @click="getInfo(page = 1)">搜索</el-button>
          <el-button type="success" icon="el-icon-plus" @click="addInfo">新增</el-button>
          <el-button type="danger" icon="el-icon-delete" style="margin-bottom:20px" @click="delInfo">删除</el-button>
          <el-button type="warning" icon="el-icon-view" style="margin-bottom:20px" @click="openVisibleDialog">班级可见范围</el-button>
        </el-row>
        <el-table
          ref="orderTable"
          :data="tableData"
          border
           @selection-change="previewChange"
          style="width: 100%">
          <el-table-column :selectable="(row) => {return row.isSelf == true}" type="selection" header-align="center" align="center" width="40"></el-table-column>
          <el-table-column type="index" header-align="center" align="center" width="80" label="序号"></el-table-column>
          <el-table-column prop="resourcesInfoName" header-align="center" align="center" label="资料名称"> </el-table-column>
          <el-table-column prop="resourcesInfoTypeText" header-align="center" align="center" label="资料类型"  width="100"> </el-table-column>
          <el-table-column prop="teacherOpenCourseIdText" header-align="center" align="center" label="归属课程" width="140"> </el-table-column>
          <el-table-column prop="teacherOpenCourseMergeCourseInfoIdText" header-align="center" align="center" label="归属章节" width="140"> </el-table-column>
          <el-table-column prop="fromTypeText" header-align="center" align="center" label="案例来源"  width="120"> </el-table-column>
          <el-table-column prop="userIdText" header-align="center" align="center" label="上传人"  width="120"> </el-table-column>
          <el-table-column prop="resourcesInfoStatusText" header-align="center" align="center" label="状态"  width="80"> </el-table-column>
          <el-table-column prop="user_" header-align="center" align="center" label="操作" width="200">
            <template slot-scope="scope">
              <template v-if="scope.row.resourcesInfoStatus == 'UP'">
                <el-link type="primary" :underline="false" class="mr10" @click="upLowerInfo(scope.row,'DOWN')">下架</el-link>
              </template>
              <template v-else>
                <el-link type="primary" :underline="false" class="mr10" @click="upLowerInfo(scope.row,'UP')">上架</el-link>
              </template>
              <el-link type="primary" :underline="false" class="mr10" @click="seeInfo(scope.row)">查看</el-link>
              <template v-if="scope.row.isSelf">
                <el-link type="primary" :underline="false" class="mr10" @click="editInfo(scope.row)">编辑</el-link>
                <el-link type="primary" :underline="false" @click="upLowerInfo(scope.row,'DEL')">删除</el-link>
              </template>
            </template>
          </el-table-column>
        </el-table>
        <div class="block" style="text-align: right;bottom: 0;width: 96%;margin: 20px;">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page"
            :page-sizes="[8, 20, 50, 100]"
            :page-size="limit"
            background
            :hide-on-single-page="true"
            layout="sizes, prev, pager, next,jumper"
            :total="total">
          </el-pagination>
        </div>

        <el-dialog
          title="资料管理"
          :visible.sync="addInfoShow"
          width="900px"
        >
          <el-form ref="form" :model="resourcesForm" label-width="100px">
            <el-form-item label="归属课程">
              <el-select @change="getCourseInfoList_gs" v-model="resourcesForm.teacherOpenCourseId" placeholder="请选择归属课程">
                <template v-for="(item ,index) in courseList">
                  <el-option :label="item.teacherOpenCourseIdText || item.teacherOpenCourseTitle" :value="item.teacherOpenCourseId"></el-option>
                </template>
              </el-select>
            </el-form-item>
            <el-form-item label="归属章">
              <el-select @change="getCourseJointList_gs" clearable v-model="resourcesForm.chapterId" placeholder="请选择章">
                <template v-for="(item ,index) in courseInfoList_gs">
                  <el-option :label="item.courseInfoName" :value="item.teacherOpenCourseMergeCourseInfoId"></el-option>
                </template>
              </el-select>
            </el-form-item>
            <el-form-item label="归属节">
              <el-select clearable v-model="resourcesForm.teacherOpenCourseMergeCourseInfoId" placeholder="请选择节">
                <template v-for="(item ,index) in jointList_gs">
                  <el-option :label="item.courseInfoName" :value="item.teacherOpenCourseMergeCourseInfoId"></el-option>
                </template>
              </el-select>
            </el-form-item>
            <el-form-item label="资源类型">
              <el-select clearable v-model="resourcesForm.resourcesInfoType" placeholder="请选择类型">
                <el-option label="视频" :value="1"></el-option>
                <el-option label="PPT" :value="2"></el-option>
                <el-option label="PDF" :value="3"></el-option>
                <el-option label="链接" :value="4"></el-option>
                <el-option label="图文" :value="5"></el-option>
              </el-select>
            </el-form-item>
            <template v-if="resourcesForm.resourcesInfoType == 1 || resourcesForm.resourcesInfoType == 2 || resourcesForm.resourcesInfoType == 3">
              <el-form-item label="上传资料">
                <UploadFiles
                  ref="taskPicture"
                  :fileLists="resourcesInfoFilesList"
                  :limit="!$isEmpty(resourcesForm.teacherOpenCourseMergeResourcesInfoId)?1:null"
                  v-if="addInfoShow"
                  @onSuccess="resourcesSuccess"
                />
              </el-form-item>
            </template>
            <template v-if="resourcesForm.resourcesInfoType == 4">
              <el-form-item label="链接名称">
                <el-input v-model="resourcesForm.resourcesInfoName" placeholder="请输入链接名称"></el-input>
              </el-form-item>
              <el-form-item label="链接地址">
                <el-input v-model="resourcesForm.resourcesInfoContent" placeholder="请输入链接地址"></el-input>
              </el-form-item>
            </template>
            <template v-if="resourcesForm.resourcesInfoType == 5">
              <el-form-item label="图文名称">
                <el-input v-model="resourcesForm.resourcesInfoName" placeholder="请输入图文名称"></el-input>
              </el-form-item>
              <el-form-item label="内容">
                <RichText ref="richText" v-if="resourcesForm.resourcesInfoType == 5" v-model="resourcesForm.resourcesInfoContent" />
              </el-form-item>
            </template>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="addInfoShow = false">取 消</el-button>
            <el-button type="primary" @click="submitAdd">确 认</el-button>
          </span>
        </el-dialog>

        <!-- 班级可见范围弹窗：按「本课程下的班级 × 章节」控制课件/资料是否对学生可见 -->
        <el-dialog
          title="班级可见范围设置"
          :visible.sync="visibleShow"
          width="960px"
          class="visible_dialog"
        >
          <div class="visible_head">
            <span class="visible_hint">勾选 = 该班可见</span>
          </div>
          <p class="visible_tip">勾选表示该班级的学生在学习端可以看到该节资料；取消勾选的节对该班学生隐藏。「全部班级」是快捷列，改动会同步到后面每个班级。</p>
          <div class="visible_matrix" v-loading="visibleLoading">
            <table class="visible_table" v-if="visibleChapterList.length > 0">
              <thead>
                <tr>
                  <th class="col_joint">章节（共{{allJointIds.length}}节）</th>
                  <th class="col_class col_all">
                    <div class="col_class_name">全部班级</div>
                    <div class="col_sub">快捷列（同步各班）</div>
                    <div class="col_sub">
                      <el-checkbox
                        :value="isUnifiedAllChecked"
                        :indeterminate="isUnifiedIndeterminate"
                        @change="toggleUnifiedAll"
                      >全选</el-checkbox>
                    </div>
                  </th>
                  <th v-for="(cls, ci) in visibleClassList" :key="'th' + ci" class="col_class">
                    <div class="col_class_name" :title="cls.schoolClassIdText">{{cls.schoolClassIdText}}</div>
                    <div class="col_sub">可见 {{classVisibleCount(cls.schoolClassId)}}/{{allJointIds.length}} 节</div>
                    <div class="col_sub">
                      <el-checkbox
                        :value="isClassAllChecked(cls.schoolClassId)"
                        :indeterminate="isClassIndeterminate(cls.schoolClassId)"
                        @change="(v) => toggleClassAll(cls.schoolClassId, v)"
                      >全选</el-checkbox>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(chapter, index) in visibleChapterList">
                  <tr :key="'ch' + index" class="row_chapter">
                    <td :colspan="visibleClassList.length + 2">{{chapter.courseInfoName}}</td>
                  </tr>
                  <tr v-for="(joint, jIndex) in chapter.jointList" :key="'jt' + index + '-' + jIndex">
                    <td class="col_joint">
                      <span>{{joint.courseInfoName}}</span>
                    </td>
                    <td class="col_class col_all">
                      <el-checkbox
                        :value="isJointAllVisible(joint.teacherOpenCourseMergeCourseInfoId)"
                        :indeterminate="isJointAllIndeterminate(joint.teacherOpenCourseMergeCourseInfoId)"
                        @change="(v) => setJointAllVisible(joint.teacherOpenCourseMergeCourseInfoId, v)"
                      ></el-checkbox>
                    </td>
                    <td v-for="(cls, ci) in visibleClassList" :key="'jt' + index + '-' + jIndex + '-' + ci" class="col_class">
                      <el-checkbox
                        :value="isJointVisibleFor(cls.schoolClassId, joint.teacherOpenCourseMergeCourseInfoId)"
                        @change="(v) => setClassVisible(cls.schoolClassId, joint.teacherOpenCourseMergeCourseInfoId, v)"
                      ></el-checkbox>
                    </td>
                  </tr>
                  <tr v-if="!chapter.jointList || chapter.jointList.length <= 0" :key="'ce' + index">
                    <td class="visible_empty" :colspan="visibleClassList.length + 2">该章暂无节</td>
                  </tr>
                </template>
              </tbody>
            </table>
            <p v-if="visibleChapterList.length <= 0 && !visibleLoading" class="visible_empty">暂无章节数据</p>
            <p v-if="visibleClassList.length <= 0 && !visibleLoading" class="visible_empty">该课程下暂无班级，请先在班级信息里添加班级</p>
          </div>
          <span slot="footer" class="dialog-footer">
            <span class="visible_foot_tip">修改后需保存才会生效</span>
            <el-button @click="visibleShow = false">取 消</el-button>
            <el-button type="primary" :loading="visibleSaving" @click="saveVisible">保存设置</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
</template>
<script>
import UploadFiles from "@/components/UploadFiles";	//上传
import RichText from '@/components/RichText/index';
import {getCourseList,getCourseInfoList,getCourseJointList} from "@/common/getInfo";	//加载数据
// 保存班级可见范围：只提交「勾选有变化的节」，每节提交当前完整的不可见班级数组（该节整体覆盖）
// 未出现在 items 的节后端不动；schoolClassIds 为空/不传 = 该节所有班级可见
const INVISIBLE_SAVE_URL = '/api/teacherOpenCourseMergeCourseInfo/setInvisibleSchoolClass.do';
export default {
  name: 'ResourcesList',
  components: {
    UploadFiles,
    RichText
  },
  props: {
    courseId: { //课程ID
      type: String,
      required:true
    }
  },
  created() {
    this.getInfo();
    this.getCourseList();
  },
  data() {
    return {
      search:{
        courseId:this.courseId,
        teacherOpenCourseMergeCourseInfoId:"",
        resourcesInfoType:"",
        resourcesInfoName:"",
      },
      tableData:[],
      total: 0,
      limit:8,
      page:1,
      pointsInfo:{},
      data: [],
      value: [],
      courseList:[],
      courseInfoList:[],
      resourcesForm:{
        courseId:"",
        teacherOpenCourseMergeCourseInfoId:""
      },
      addInfoShow:false,
      courseInfoList_gs:[],
      jointList_gs:[],
      onIds:"",
      resourcesInfoFilesList:[],
      visibleShow:false, //班级可见范围弹窗
      visibleLoading:false,
      visibleSaving:false,
      visibleChapterList:[], //章列表（含每章下的节）
      visibleClassList:[], //本课程下的全部班级 [{schoolClassId, schoolClassIdText}]
      visibleClassMap:{}, //按班级的可见范围 {班级ID: {节ID: 1可见 / 0不可见}}
      jointInvisibleMap:{}, //节 → 不可见班级ID数组，来自章节树 invisibleSchoolClassIds（后端唯一数据源）
      visibleSnapshot:{}, //打开弹窗时的「班级 × 节」可见状态，保存时用于判断哪些节被改过
      allJointIds:[] //本课程全部节ID，用于全选与统计
    }
  },
  computed: {
    isUnifiedAllChecked(){ //全部班级：所有节对所有班都可见
      if(this.allJointIds.length <= 0 || this.visibleClassList.length <= 0) return false;
      return this.allJointIds.every((jid) => this.isJointAllVisible(jid));
    },
    isUnifiedIndeterminate(){ //全部班级：部分可见
      if(this.allJointIds.length <= 0 || this.visibleClassList.length <= 0) return false;
      let n = 0;
      this.allJointIds.forEach((jid) =>{ if(this.isJointAllVisible(jid)) n++; });
      return n > 0 && n < this.allJointIds.length;
    }
  },methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.limit = val;
      this.getInfo();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.getInfo();
    },
    getInfo(){ //获取分页数据
      let param = {
        limit:this.limit,
        page:this.page,
        teacherOpenCourseId:this.courseId
      }
      param = Object.assign(this.search,param);
      param.teacherOpenCourseId = !this.$isEmpty(this.search.courseId)?this.search.courseId:this.courseId
      this.$post("/api/teacherOpenCourseMergeResourcesInfo/getPageList.do",param).then((ret) =>{
        if(ret.code == 0){
          this.total = Number(ret.count);
          this.tableData = ret.data;
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    addInfo(){ //添加
      this.resourcesForm = {};
      this.resourcesInfoFilesList = [];
      this.addInfoShow = true;
    },
    editInfo(item){ //编辑
      this.resourcesForm = item;
      this.resourcesInfoFilesList = [
        {
          fileName:item.resourcesInfoName,
          fileUrl:item.resourcesInfoContent,
        }
      ];
      this.getCourseInfoList_gs();
      this.addInfoShow = true;
      if(this.resourcesForm.resourcesInfoType == 5){
        setTimeout(()=>{
          this.$refs.richText.content = this.resourcesForm.resourcesInfoContent; //清空编辑框
        },100)
      }
    },
    submitAdd(){ //提交添加/修改信息
      if(this.$isEmpty(this.resourcesForm.teacherOpenCourseId)){
        this.$message.warning("请选择归属课程！");
        return;
      }
      if(this.$isEmpty(this.resourcesForm.resourcesInfoType)){
        this.$message.warning("请选择资源类型！");
        return;
      }
      if(this.resourcesForm.resourcesInfoType == 1 || this.resourcesForm.resourcesInfoType == 2 || this.resourcesForm.resourcesInfoType == 3){
        if(this.resourcesInfoFilesList.length <=0){
          this.$message.warning("请选择需要上传的资料！");
          return;
        }
        this.resourcesForm.resourcesInfoFiles = "";
        this.resourcesForm.resourcesInfoName = "";
        for(var i = 0;i < this.resourcesInfoFilesList.length;i++){
          this.resourcesForm.resourcesInfoFiles += this.resourcesInfoFilesList[i].fileUrl;
          this.resourcesForm.resourcesInfoName += this.resourcesInfoFilesList[i].fileName;
          if(i < this.resourcesInfoFilesList.length - 1){
            this.resourcesForm.resourcesInfoFiles += ",";
            this.resourcesForm.resourcesInfoName += ",";
          }
        }
      }
      if(this.resourcesForm.resourcesInfoType == 4){
        if(this.$isEmpty(this.resourcesForm.resourcesInfoName)){
          this.$message.warning("请输入链接名称！");
          return;
        }
        if(this.$isEmpty(this.resourcesForm.resourcesInfoContent)){
          this.$message.warning("请输入链接地址！");
          return;
        }
      }

      if(this.resourcesForm.resourcesInfoType == 5){
        if(this.$isEmpty(this.resourcesForm.resourcesInfoName)){
          this.$message.warning("请输入图文名称！");
          return;
        }
        if(this.$isEmpty(this.resourcesForm.resourcesInfoContent)){
          this.$message.warning("请输入内容！");
          return;
        }
      }
      let url = "/api/teacherOpenCourseMergeResourcesInfo/batchAdd.do";
      if(this.resourcesInfoFilesList.length <= 0){
        url = "/jlw/teacherOpenCourseMergeResourcesInfo/add.json";
      }
      if(!this.$isEmpty(this.resourcesForm.teacherOpenCourseMergeResourcesInfoId)){
        url= "/api/teacherOpenCourseMergeResourcesInfo/edit.do"
      }

      this.$post(url,this.resourcesForm).then((ret) =>{
        if(ret.code == 0){
          if(this.resourcesForm.resourcesInfoType == 5){
            this.$refs.richText.content = ""; //清空编辑框
          }
          this.addInfoShow = false;
          this.$message.success("操作成功！");
          this.getInfo();
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    seeInfo(item){ //查看
      if(item.resourcesInfoType == 4){
        window.open(item.resourcesInfoContent.indexOf("http") == 0?item.resourcesInfoContent:"http://"+item.resourcesInfoContent);
        return;
      }else{
        this.$ls.set(this.$getKeyInfo("TCoursewareViewingInfo"),item);
        this.$router.push({name:'TCoursewareViewing'});
      }
    },
    previewChange(val) {
      this.onIds = '';
      for (let index = 0; index < val.length; index++) {
        this.onIds += val[index].teacherOpenCourseMergeResourcesInfoId +",";
      }
    },
    delInfo(){ //删除
      if(this.$isEmpty(this.onIds)){
        this.$message.warning("请选择需要删除的资料！");
        return;
      }
      this.$post("/api/teacherOpenCourseMergeResourcesInfo/updateStatus.do",{ids:this.onIds,status:"DEL"}).then((ret) =>{
        if(ret.code == 0){
          this.$message.success("删除成功！");
          this.getInfo();
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    upLowerInfo(item,status){ //上下架
      let param = {
        ids:item.teacherOpenCourseMergeResourcesInfoId,
        status:status //UP，DOWN，DEL
      }
      this.$post("/api/teacherOpenCourseMergeResourcesInfo/updateStatus.do",param).then((ret) =>{
        if(ret.code == 0){
          this.$message.success("操作成功！");
          this.getInfo();
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    getCourseList(){ //获取课程
      if(this.courseList.length <= 0){
        getCourseList().then((ret) =>{
          if(ret.code == 0){
            this.courseList = ret.data;
            this.search.courseId = this.courseId;
            this.getCourseInfoList();
          }
        });
      }else{
        this.search.courseId = this.courseId;
        this.getCourseInfoList();
      }
    },
    getCourseInfoList(){ //获取章节
      if(this.$isEmpty(this.search.courseId)){
        this.courseInfoList = [];
        this.search.teacherOpenCourseMergeCourseInfoId = "";
        return;
      }
      getCourseInfoList({teacherOpenCourseId:this.search.courseId}).then((ret) =>{
        if(ret.code == 0){
          this.courseInfoList = ret.data;
        }
      });
    },
    getCourseInfoList_gs(){
      if(this.$isEmpty(this.resourcesForm.teacherOpenCourseId)){
        this.courseInfoList_gs = [];
        this.jointList_gs = [];
        this.resourcesForm.chapterId = "";
        this.resourcesForm.teacherOpenCourseMergeCourseInfoId = "";
        return;
      }
      getCourseInfoList({teacherOpenCourseId:this.resourcesForm.teacherOpenCourseId}).then((ret) =>{
        if(ret.code == 0){
          this.courseInfoList_gs = ret.data;
        }
      });
    },
    getCourseJointList_gs(){
      if(this.$isEmpty(this.resourcesForm.chapterId)){
        this.jointList_gs = [];
        this.resourcesForm.teacherOpenCourseMergeCourseInfoId = "";
        return;
      }
      getCourseJointList({courseInfoParentId:this.resourcesForm.chapterId}).then((ret) =>{
        if(ret.code == 0){
          this.jointList_gs = ret.data;
        }
      });
    },
    resourcesSuccess(file){ //上传成功回调
      this.resourcesInfoFilesList = [];
      for(let i in file){
        this.resourcesInfoFilesList.push(
        {
          fileName:file[i].name,
          fileUrl:file[i].url,
        });
      }
    },
    openVisibleDialog(){ //打开班级可见范围弹窗：章节树（节点带 invisibleSchoolClassIds）+ 本课程下全部班级
      this.visibleShow = true;
      this.visibleLoading = true;
      this.visibleChapterList = [];
      this.visibleClassMap = {};
      this.visibleClassList = [];
      this.jointInvisibleMap = {};
      this.visibleSnapshot = {};
      this.allJointIds = [];
      let classJob = this.$get("/api/teacherOpenCourseMergeSchoolClass/getList.do", { //本课程下的所有班级
        teacherOpenCourseId:this.courseId,
        teacherOpenCourseMergeSchoolClassStatus:1
      }).then((cRet) =>{
        if(cRet.code == 0){
          this.visibleClassList = (cRet.data || []).filter((c) => !this.$isEmpty(c.schoolClassId));
        }
      }).catch(() =>{});
      //章节树：每个节点带 invisibleSchoolClassIds（不可见班级ID，逗号分隔），是可见范围的唯一数据源
      let treeJob = this.$post("/api/teacherOpenCourseMergeCourseInfo/getTreeByTeacherOpenCourseId.do", {
        teacherOpenCourseId:this.courseId
      }).then((tRet) =>{
        if(tRet.code != 0){
          this.$message({message: tRet.msg || '章节树加载失败', type: 'error'});
          return;
        }
        let chapterList = (tRet.data && tRet.data.children) ? tRet.data.children : [];
        chapterList.forEach((chapter) =>{
          chapter.jointList = (chapter.children || []).filter((j) => j.courseInfoType == 3); //只看 courseInfoType=3 的节
          chapter.jointList.forEach((joint) =>{
            let jid = joint.teacherOpenCourseMergeCourseInfoId;
            this.allJointIds.push(jid);
            this.$set(this.jointInvisibleMap, jid, this.parseIds(joint.invisibleSchoolClassIds));
          });
        });
        this.visibleChapterList = chapterList;
      });
      Promise.all([classJob, treeJob]).then(() =>{
        this.syncClassMapFromInvisible();
        this.visibleLoading = false;
      }).catch(() =>{
        this.visibleLoading = false;
      });
    },
    parseIds(val){ //"211,216" → ["211","216"]；空值返回空数组
      if(this.$isEmpty(val)) return [];
      return String(val).split(",").map((s) => s.trim()).filter((s) => s !== "");
    },
    syncClassMapFromInvisible(){ //按班级展开：节的不可见班级列表含该班 → 该班不可见
      this.visibleClassList.forEach((cls) =>{
        let m = {};
        this.allJointIds.forEach((jid) =>{
          let inv = this.jointInvisibleMap[jid] || [];
          //"*"/"ALL" 表示该节对全部班级都不可见（保存时不传 schoolClassIds 的整节隐藏）
          let allHidden = inv.indexOf("*") >= 0 || inv.indexOf("ALL") >= 0;
          m[jid] = allHidden || inv.indexOf(String(cls.schoolClassId)) >= 0 ? 0 : 1;
        });
        this.$set(this.visibleClassMap, cls.schoolClassId, m);
      });
      this.snapshotVisible();
    },
    snapshotVisible(){ //记录打开弹窗时的状态，保存时据此挑出「被改过的节」
      let snap = {};
      this.visibleClassList.forEach((cls) =>{
        let m = {};
        this.allJointIds.forEach((jid) =>{ m[jid] = this.isJointVisibleFor(cls.schoolClassId, jid) ? 1 : 0; });
        snap[cls.schoolClassId] = m;
      });
      this.visibleSnapshot = snap;
    },
    /* ===== 班级 × 节 勾选状态 ===== */
    isJointVisibleFor(classId, jid){ //某班某节是否可见（缺省可见）
      let m = this.visibleClassMap[classId];
      if(!m) return true;
      return m[jid] !== 0;
    },
    setClassVisible(classId, jid, val){ //某班某节开关
      let m = this.visibleClassMap[classId] || {};
      this.$set(m, jid, val ? 1 : 0);
      this.$set(this.visibleClassMap, classId, m);
    },
    classVisibleCount(classId){ //某班可见节数
      let m = this.visibleClassMap[classId] || {};
      let n = 0;
      this.allJointIds.forEach((jid) =>{ if(m[jid] !== 0) n++; });
      return n;
    },
    isClassAllChecked(classId){
      if(this.allJointIds.length <= 0) return false;
      return this.classVisibleCount(classId) === this.allJointIds.length;
    },
    isClassIndeterminate(classId){
      let n = this.classVisibleCount(classId);
      return n > 0 && n < this.allJointIds.length;
    },
    toggleClassAll(classId, val){ //某班整列全选/取消
      let m = this.visibleClassMap[classId] || {};
      this.allJointIds.forEach((jid) =>{ this.$set(m, jid, val ? 1 : 0); });
      this.$set(this.visibleClassMap, classId, m);
    },
    /* ===== 「全部班级」快捷列：只改前端状态，保存时仍按班拆成增量 ===== */
    isJointAllVisible(jid){ //该节是否对所有班都可见
      if(this.visibleClassList.length <= 0) return true;
      return this.visibleClassList.every((cls) => this.isJointVisibleFor(cls.schoolClassId, jid));
    },
    isJointAllIndeterminate(jid){ //该节部分班可见
      if(this.visibleClassList.length <= 0) return false;
      let n = 0;
      this.visibleClassList.forEach((cls) =>{ if(this.isJointVisibleFor(cls.schoolClassId, jid)) n++; });
      return n > 0 && n < this.visibleClassList.length;
    },
    setJointAllVisible(jid, val){ //单节对所有班同步
      this.visibleClassList.forEach((cls) =>{
        this.setClassVisible(cls.schoolClassId, jid, val);
      });
    },
    toggleUnifiedAll(val){ //全部节对所有班全选/取消
      this.visibleClassList.forEach((cls) =>{
        let m = {};
        this.allJointIds.forEach((jid) =>{ m[jid] = val ? 1 : 0; });
        this.$set(this.visibleClassMap, cls.schoolClassId, m);
      });
    },
    saveVisible(){ //保存：只提交「勾选有变化的节」，每节带当前完整的不可见班级数组（该节整体覆盖）
      if(this.visibleClassList.length <= 0){
        this.$message({message: '该课程下暂无班级，无需设置', type: 'warning'});
        return;
      }
      //1) 与打开时的快照比，挑出任意班级状态发生变化的节（没变的节不提交，后端不动）
      let changedJointIds = this.allJointIds.filter((jid) =>{
        return this.visibleClassList.some((cls) =>{
          let was = (this.visibleSnapshot[cls.schoolClassId] || {})[jid];
          was = (was === 0) ? 0 : 1;
          let now = this.isJointVisibleFor(cls.schoolClassId, jid) ? 1 : 0;
          return was !== now;
        });
      });
      if(changedJointIds.length <= 0){
        this.$message({message: '没有需要保存的修改', type: 'warning'});
        return;
      }
      //2) 每个变化的节提交它当前「不可见班级」全量数组：为空 → 该节所有班级都可见（不带 schoolClassIds）
      let items = changedJointIds.map((jid) =>{
        let ids = [];
        this.visibleClassList.forEach((cls) =>{
          if(!this.isJointVisibleFor(cls.schoolClassId, jid)) ids.push(String(cls.schoolClassId));
        });
        if(ids.length <= 0) return {courseInfoId:String(jid)};
        return {courseInfoId:String(jid), schoolClassIds:ids};
      });
      this.visibleSaving = true;
      this.$postJSON(INVISIBLE_SAVE_URL, {
        teacherOpenCourseId:this.courseId,
        items:items
      }).then((ret) =>{
        this.visibleSaving = false;
        if(ret.code != 0){
          this.$message({message: ret.msg || '可见范围保存失败', type: 'error'});
          return;
        }
        //3) 成功后按刚提交的内容同步本地「节 → 不可见班级」，并刷新快照
        items.forEach((item) =>{
          this.$set(this.jointInvisibleMap, item.courseInfoId, (item.schoolClassIds || []).slice());
        });
        this.snapshotVisible();
        this.visibleShow = false;
        //data 返回实际更新的节数，非数字时退回前端提交的数量
        let updated = (typeof ret.data === "number") ? ret.data : items.length;
        this.$message({message: '可见范围已保存，更新 ' + updated + ' 个节', type: 'success'});
      }).catch(() =>{
        this.visibleSaving = false;
        this.$message({message: '可见范围保存失败', type: 'error'});
      });
    },

  }
};
</script>
<style  lang="less">
  .course_ResourcesList{
    padding: 20px;
    border: 1px solid #DEDEDE;
    .title_practice{
      margin: 0;
      margin-left: 15px;float: left;
      width: calc(100% - 155px);
    }
    .number_practice{
      margin: 0;
      float: right;
      width: 140px;
      text-align: right;
    }
    .grade_Practice{
      display: flex;
      justify-content:center;
      align-items:center;
      width: 80px;height: 80px;margin: 0 auto;
      font-size: 22px;
      color: #F83131;
      background-color: #FFF6F6;
      border-radius: 50%;
      span{
        font-size: 14px;
        margin-left: 2px;
      }
    }
    .practice_img{
      width: 30px;
      height: 30px;
    }
    .el-transfer-panel{
      width: 280px !important;
    }
    .visible_tip{
      margin: 0 0 10px;
      font-size: 13px;
      color: #909399;
    }
    .visible_head{
      display: flex;
      align-items: center;
      margin-bottom: 6px;
      .visible_hint{
        margin-left: auto;
        font-size: 13px;
        color: #909399;
      }
    }
    .visible_matrix{
      max-height: 460px;
      overflow: auto;
      border: 1px solid #EBEEF5;
    }
    .visible_table{
      width: 100%;
      border-collapse: collapse;
      font-size: 14px;
      th, td{
        padding: 8px 10px;
        border: 1px solid #EBEEF5;
        color: #606266;
      }
      thead th{
        background: #F5F7FA;
        color: #303133;
        font-weight: bold;
        text-align: center;
      }
      .col_joint{
        min-width: 260px;
        text-align: left;
      }
      .col_class{
        width: 130px;
        text-align: center;
      }
      .col_all{ //「全部班级」快捷列，浅蓝底与班级列区分
        background: #F5F9FD;
      }
      .col_class_name{
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .col_sub{
        margin-top: 2px;
        font-size: 12px;
        font-weight: normal;
        color: #909399;
      }
      .row_chapter td{
        background: #FAFAFA;
        font-weight: bold;
        color: #303133;
      }
    }
    .visible_foot_tip{
      float: left;
      line-height: 32px;
      font-size: 13px;
      color: #909399;
    }
    .visible_empty{
      margin: 10px 0;
      font-size: 13px;
      color: #909399;
      text-align: center;
    }
    @media screen and (max-width:1536px){
      li{
        width: calc(33% - 66px);
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/Teacher/components/ResourcesList.vue